import e from "./generateUtilityClass.mjs";
import a from "./generateUtilityClasses.mjs";
const n = (t) => e("MuiDateCalendar", t);
a("MuiDateCalendar", ["root", "viewTransitionContainer"]);
export {
  n as getDateCalendarUtilityClass
};
//# sourceMappingURL=dateCalendarClasses.mjs.map
